import { DateUtils } from '../../../common/utils/DateUtils';
import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { OrganizationCertificate } from '../models/OrganizationCertificate';
import { PublicKey } from '../../../common/certificates/models/valueObjects/PublicKey';

export class OrganizationCertificateMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): OrganizationCertificate {
    const publicKey = new PublicKey(this.gqlIdEncoder.decode(data.publicKey.id), data.publicKey.shortDescription, data.publicKey.hasPrivateKey);
    const expiryDate = data.notAfter ? DateUtils.toMoment(data.notAfter) : null;

    return new OrganizationCertificate(
      this.gqlIdEncoder.decode(data.id),
      data.subject,
      data.issuer,
      publicKey,
      data.fingerprint,
      expiryDate,
      data.signatureAlgorithm?.digest ?? null,
      data.reportCertificates.totalCount
    );
  }
}
